import type { ManagedCallSummary } from '@repo/sdk/gen'
import { currentCallOf } from './current-call'

/** The academic year as the address writes it, `2026-2027`, and as the API does, `2026/2027`. */
export const annoOf = (academicYear: string) => academicYear.replace('/', '-')

/**
 * The call of a residence the pages of the call are showing: the one of the
 * academic year in the address (`anno`), or without it the current call. The
 * pages send its id with every read and command, also for the current call, so
 * a year that turned into a year before while the page stayed open is refused
 * instead of acting on the call that came after. A year with no call of the
 * residence has none to show: `callId` stays empty.
 */
export function workingCallOf(
	list: ManagedCallSummary[],
	residenceId: string,
	anno: string | undefined
) {
	const own = list.filter((item) => item.residence.id === residenceId)
	const current = currentCallOf(own)
	const chosen = anno
		? own.find((item) => annoOf(item.call.academicYear) === anno)
		: current
	return chosen
		? {
				callId: chosen.call.id,
				academicYear: chosen.call.academicYear,
				readOnly: chosen.call.readOnly,
				state: chosen.call.state,
				isCurrent: chosen === current
			}
		: {
				callId: undefined,
				academicYear: undefined,
				readOnly: false,
				state: undefined,
				isCurrent: false
			}
}
